import { ReactComponent as DeezerColorLight } from 'fym-shared/src/music-services/assets/images/deezer-color-light.svg';
import { ReactComponent as DeezerColorDark } from 'fym-shared/src/music-services/assets/images/deezer-color-dark.svg';
import { ReactComponent as DeezerColorLightPadding } from 'fym-shared/src/music-services/assets/images/deezer-color-light-padding.svg';
import { ReactComponent as DeezerColorDarkPadding } from 'fym-shared/src/music-services/assets/images/deezer-color-dark-padding.svg';
import { MusicServiceImages } from './types';

export const deezerImages: MusicServiceImages = {
  logoColor: {
    light: DeezerColorLight,
    dark: DeezerColorDark,
  },
  logoColorPadding: {
    light: DeezerColorLightPadding,
    dark: DeezerColorDarkPadding,
  },
};
